import { AppContainer } from "twyne-new.ui";

export default function AppContent({ children }) {
  return <AppContainer>
    {children}
  </AppContainer>
}
